import { Fragment } from 'react';
import { Container } from '@/components/ui/container';

const metrics = [
  { value: '$10B+', label: 'Transacted' },
  { value: '400+', label: 'Onchain teams' },
  { value: '99.9%', label: 'Availabilty' },
  { value: '24/7', label: 'Support' },
] as const;

export function Metrics() {
  return (
    <section className="bg-slate-50 border-b border-hairline dots-matrix">
      {/* 2×2 grid on mobile (four large stats don't fit in one row), a single
          row of four on sm+. */}
      <Container className="metrics-halo grid grid-cols-2 gap-x-6 gap-y-10 py-12 sm:flex sm:h-[206px] sm:flex-row sm:items-stretch sm:justify-between sm:gap-16 sm:py-0">
        {metrics.map((m, i) => (
          <Fragment key={m.label}>
            {i > 0 && (
              <div aria-hidden className="h-[90%] w-px bg-hairline hidden" />
            )}
            <div className="text-center flex flex-col items-center justify-center">
              <div className="text-4xl font-base tracking-tight text-slate-800 sm:text-5xl">
                {m.value}
              </div>
              <div className="mt-2.5 text-xs font-medium uppercase tracking-[0.14em] text-ink-400">
                {m.label}
              </div>
            </div>
          </Fragment>
        ))}
      </Container>
    </section>
  );
}
